import Typography from "@mui/material/Typography";
import {
  Button,
  Grid,
  IconButton,
  TextField,
  LinearProgress,
  Card,
  CardContent,
  Stack,
  Tooltip,
  Chip,
  Link,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridPagination,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { User } from "../../../../../../app/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  HiOutlineArrowDownTray,
  HiOutlineArrowsRightLeft,
  HiOutlineBanknotes,
  HiOutlineBolt,
  HiOutlinePencilSquare,
  HiOutlinePlusCircle,
  HiOutlineUserCircle,
  HiOutlineWallet,
} from "react-icons/hi2";
import {
  MobileBadge,
  MobileEmpty,
  MobileListItem,
  MobileListShell,
  MobilePagination,
  TONE,
} from "../../../../../../components/MobileList";
import { MdOutlineClear } from "react-icons/md";
import TransactionForm from "../../form";
import { PointOfSales } from "../../../../../../app/slices/posSlice";
import PosForm from "../../../../../POS/form";
import { ExportButton } from "../../../../../../components/ExportExcel/ExportButton";
import ConfirmationDialog from "../../../../../../helpers/ConfirmationDialog";
import {
  JClearance,
  setCashFromPosDialog,
  setCashFromRepDialog,
  setJTransactionDialog,
  setSearchBody,
} from "../../../../../../app/slices/jomla/clearanceSlice";
import { BiInfoCircle } from "react-icons/bi";
import { SelectJTransaction } from "../../../../../../components/Selectors/jomla/SelectTransactionTypes";
import { SelectPos } from "../../../../../../components/Selectors/SelectPos";
import { useTheme } from "@emotion/react";
import Permission from "../../../../../../components/userPermission/userPermission";
import DateRangepicker from "../../../../../../helpers/dateRangePicker";
import { restoreFilters } from "../../../../../../helpers/restoreFilters";
import {
  InfoCardHeader,
  InfoField,
  StatTile,
  actionButtonSx,
  infoContentSx,
} from "../../../../../../components/InfoCard";

const JTransactionTable = () => {
  const dispatch = useDispatch();

  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const { user_id } = useParams();
  const [pageSize, setPageSize] = useState(15);
  const [currentPage, setCurrentPage] = useState(0);
  const searchBody = useSelector((state) => state.jClearance.searchBody);
  // searchBody has other keys per role and is shared by users; only restore
  // what was written for this same user. Keys are renamed/stringified.
  const [search, setSearch] = useState(() => {
    const same = [searchBody.user_id, searchBody.rep_id].some(
      (id) => id !== undefined && String(id) === String(user_id),
    );
    const saved = same
      ? {
          ...searchBody,
          startDate: searchBody.start_date,
          endDate: searchBody.end_date,
          j_type_id: searchBody.j_type_id
            ? JSON.parse(searchBody.j_type_id)
            : undefined,
        }
      : {};
    return restoreFilters(
      {
        search: "",
        order_id: "",
        user_type: null,
        date: "",
        j_type_id: null,
        is_received: null,
        startDate: null,
        endDate: null,
        skip: 0,
        number: "",
        order_number: "",
        pos_user_id: null,
      },
      saved,
    );
  });

  const _JTransactions = useSelector((state) => state.jClearance.jClearances);
  const cashFromRepActiveDelay = useSelector(
    (state) => state.jClearance.cashFromRep.isActiveDelay
  );
  const cashFromPosActiveDelay = useSelector(
    (state) => state.jClearance.cashFromPos.isActiveDelay
  );
  const trasactionActiveDelay = useSelector(
    (state) => state.jClearance.jtransaction.isActiveDelay
  );
  const _JPosTransactions = useSelector(
    (state) => state.jClearance.jPosTransaction
  );
  const user = useSelector((state) => state.user.user.form);
  const _Wallet = useSelector((state) => state.wallet);
  const _PointsOfsales = useSelector((state) => state.pointOfsales);
  const _JTransactionTypes = useSelector(
    (state) => state.jTransaction.jTransactionTypes.data
  );

  const [reload, setReload] = useState(false);
  const [openActive, setOpenActive] = useState(false);
  const [dialogActiveData, setDialogActiveData] = useState({});

  const columns = [
    {
      field: "number",
      headerName: "رقم المناقلة",
      flex: 1,
    },
    {
      field: "pos_user_name",
      headerName: "نقطة البيع",
      flex: 1,
    },
    {
      field: "amount",
      headerName: "القيمة (IQD)",
      flex: 1,
      renderCell: (params) => params.row.amount?.toLocaleString(),
    },
    {
      field: "created_by_name",
      headerName: "بواسطة",
      flex: 1,
    },
    {
      field: "rep_name",
      headerName: "المندوب",
      flex: 1,
    },
    {
      field: "rep_j_cash",
      headerName: "الرصيد السابق (IQD)",
      flex: 1,
      renderCell: (params) => params.row.rep_j_cash?.toLocaleString(),
    },
    {
      field: "rep_new_j_cash",
      headerName: "الرصيد الحالي (IQD)",
      flex: 1,
      renderCell: (params) => params.row.rep_new_j_cash?.toLocaleString(),
    },
    {
      field: "pos_j_balance_before",
      headerName: "الديون السابقة (IQD)",
      flex: 1,
      renderCell: (params) => params.row.pos_j_balance_before?.toLocaleString(),
    },
    {
      field: "pos_j_balance_after",
      headerName: "الديون الحالية (IQD)",
      flex: 1,
      renderCell: (params) => params.row.pos_j_balance_after?.toLocaleString(),
    },
    {
      field: "is_received",
      headerName: "نوع العملية (IQD)",
      flex: 1,
      renderCell: (params) => (params.row.is_received ? "استلام" : "تسديد"),
    },
    {
      field: "created_at",
      headerName: "تاريخ العملية",
      flex: 1,
      renderCell: (params) => {
        return (
          <Stack spacing={1} alignItems="center">
            <Typography>
              {dayjs(params.row.created_at).format("YYYY-MM-DD")}
              {params.row.note && (
                <Tooltip title={params.row.note}>
                  <IconButton size="small">
                    <BiInfoCircle />
                  </IconButton>
                </Tooltip>
              )}
            </Typography>
            <Typography>
              {dayjs(params.row.created_at).format("hh:mm: a")}
            </Typography>
          </Stack>
        );
      },
    },
  ];

  const posColumns = [
    {
      field: "number",
      headerName: "رقم المناقلة",
      flex: 1,
    },
    {
      field: "j_order_id",
      headerName: "رقم الطلب",
      flex: 1,
      renderCell: (params) => (
        <Link
          href={`/app/wholesale/order/${params.row.j_order_id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {params.row?.j_order_number}
        </Link>
      ),
    },
    {
      field: "amount",
      headerName: "القيمة (IQD)",
      flex: 1,
      renderCell: (params) => params.row.amount?.toLocaleString(),
    },
    {
      field: "created_by",
      headerName: "بواسطة",
      flex: 1,
    },
    // {
    //   field: "main_j_balance",
    //   headerName: "رصيد الخزنة (IQD)",
    //   flex: 1,
    //   renderCell: (params) => params.row.main_j_balance?.toLocaleString(),
    // },
    // {
    //   field: "new_main_j_balance",
    //   headerName: "رصيد الخزنة الجديد (IQD)",
    //   flex: 1,
    //   renderCell: (params) => params.row.new_main_j_balance?.toLocaleString(),
    // },
    {
      field: "pos_j_balance",
      headerName: "الديون السابقة (IQD)",
      flex: 1,
      renderCell: (params) => params.row.pos_j_balance?.toLocaleString(),
    },
    {
      field: "new_pos_j_balance",
      headerName: "الديون الحالية (IQD)",
      flex: 1,
      renderCell: (params) => params.row.new_pos_j_balance?.toLocaleString(),
    },
    {
      field: "j_type_name",
      headerName: "نوع العملية",
      flex: 1,
      renderCell: (params) => {
        return (
          <Stack direction={"row"} spacing={1}>
            <Typography>{params.row.j_type_name}</Typography>
            {params.row.note && (
              <Tooltip title={params.row.note}>
                <IconButton size="small">
                  <BiInfoCircle />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        );
      },
    },
    {
      field: "created_at",
      headerName: "تاريخ العملية",
      flex: 1,
      renderCell: (params) => {
        return (
          <Stack spacing={1} alignItems="center">
            <Typography>
              {dayjs(params.row.created_at).format("YYYY-MM-DD ")}
            </Typography>
            <Typography>
              {dayjs(params.row.created_at).format("hh:mm: a")}
            </Typography>
          </Stack>
        );
      },
    },
  ];

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (user.role === "pos") {
        dispatch(JClearance.getAllPosTransactions(searchBody));
      } else {
        dispatch(JClearance.getAll(searchBody));
      }
    }, 500);
    return () => clearTimeout(timeout);
  }, [dispatch, searchBody, user.role]);

  useEffect(() => {
    if (user.role === "pos") {
      dispatch(
        setSearchBody({
          user_id: user_id,
          skip: currentPage * pageSize,
          take: pageSize,
          j_type_id: search.j_type_id ? JSON.stringify(search.j_type_id) : "",
          start_date: search.startDate,
          end_date: search.endDate,
          number: search.number,
          order_number: search.order_number,
        })
      );
    } else {
      dispatch(
        setSearchBody({
          rep_id: user_id,
          skip: currentPage * pageSize,
          take: pageSize,
          type: search.type ? JSON.stringify(search.type) : "",
          is_received: search.is_received !== null ? search.is_received : "",
          start_date: search.startDate,
          end_date: search.endDate,
          pos_user_id: search.pos_user_id,
        })
      );
    }
  }, [currentPage, dispatch, pageSize, search, user.role, user_id]);

  useEffect(() => {
    dispatch(User.getByIdData(user_id));
  }, [user_id, _Wallet.reload, dispatch, reload]);

  const getUserType = (_user) => {
    if (_user.is_representative) return "مندوب";
    else if (_user.is_j_rep) return "مندوب جملة";
    else if (_user.role === "pos")
      return `نقطة بيع : ${_user.pos_number ? `(${_user.pos_number})` : ""}`;
    else return "غير معرف";
  };

  function CustomFooter() {
    return (
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography color="primary" sx={{ marginX: 2 }}>
          القيمة الكلية : {_JTransactions.total_amount.toLocaleString()} (IQD)
        </Typography>
        <GridPagination />
      </Stack>
    );
  }

  const customToolbar = () => (
    <GridToolbarContainer>
      <ExportButton fileName="تقرير كشف الحساب | نظام دجلة" />

      {/* <GridToolbarExport
        csvOptions={{
          fileName: "تقرير كشف الحساب | نظام دجلة",
          utf8WithBom: true,
        }}
      /> */}
    </GridToolbarContainer>
  );

  const handleActiveClick = (params) => {
    setOpenActive(true);
    setDialogActiveData(params);
  };

  const handleConfirmActive = () => {
    dispatch(
      User.WalletActivation({
        user_id: dialogActiveData.id,
        is_active: !dialogActiveData.wallet?.is_active,
      })
    )
      .then((x) => {
        setReload(!reload);
      })
      .catch((e) => {
        setReload(!reload);
      });
    setOpenActive(false);
  };

  const handleCancelActive = () => {
    setOpenActive(false);
  };

  return (
    <Card>
      <CardContent>
        <Box>
          <TransactionForm />
          {_PointsOfsales.pos.dialog ? <PosForm /> : null}
          <ConfirmationDialog
            open={openActive}
            title="تاكيد"
            message={
              dialogActiveData.wallet?.is_active
                ? "هل انت متاكد من الغاء تفعيل المحفظة: "
                : "هل انت متاكد من تفعيل المحفظة :"
            }
            name={dialogActiveData.user_name}
            confirmText="تاكيد"
            cancelText="الغاء"
            onConfirm={() => handleConfirmActive()}
            onCancel={handleCancelActive}
          />
        </Box>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2} sx={{ mb: 1 }}>
              <Grid item xs={12} md={4}>
                <Card sx={{ height: "100%" }}>
                  <InfoCardHeader
                    icon={<HiOutlineUserCircle />}
                    tone={TONE.brand}
                    title="معلومات المستخدم"
                    action={
                      <Permission permission="pos_edit">
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<HiOutlinePencilSquare />}
                          onClick={() =>
                            dispatch(PointOfSales.getById(user.pos_id))
                          }
                          sx={{ py: 0.25 }}
                        >
                          تعديل
                        </Button>
                      </Permission>
                    }
                  />
                  <CardContent sx={infoContentSx}>
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        columnGap: 2,
                        rowGap: 1,
                      }}
                    >
                      <InfoField label="الاسم">{user?.name}</InfoField>
                      <InfoField label="رقم الهاتف">{user?.mobile}</InfoField>
                      <InfoField label="نوع الحساب">
                        {user ? getUserType(user) : ""}
                      </InfoField>
                      <InfoField label="حالة المحفظة">
                        <Chip
                          label={user.wallet?.is_active ? "فعال" : "غير فعال"}
                          color={user.wallet?.is_active ? "success" : "error"}
                          size="small"
                          onClick={() => {
                            handleActiveClick(user);
                          }}
                          sx={{ height: 20, fontSize: 11 }}
                        />
                      </InfoField>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {user.is_j_rep || user.role === "pos" ? (
                <Grid item xs={12} md={4}>
                  <Card sx={{ height: "100%" }}>
                    <InfoCardHeader
                      icon={<HiOutlineWallet />}
                      tone={TONE.success}
                      title="المعلومات المالية"
                    />
                    <CardContent sx={infoContentSx}>
                      <Stack direction="row" flexWrap="wrap" gap={1}>
                        {user.role === "pos" && (
                          <StatTile
                            label="الديون"
                            value={user.wallet?.j_balance}
                            tone={TONE.danger}
                          />
                        )}
                        {user.is_j_rep && (
                          <StatTile
                            label="الكاش"
                            value={user.wallet?.j_cash}
                            tone={TONE.brand}
                          />
                        )}
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>
              ) : null}

              <Grid item xs={12} md={4}>
                <Card sx={{ height: "100%" }}>
                  <InfoCardHeader
                    icon={<HiOutlineBolt />}
                    tone={TONE.warning}
                    title="العمليات المتاحة"
                  />
                  <CardContent sx={infoContentSx}>
                    <Stack direction="row" flexWrap="wrap" gap={0.75}>
                      <Permission permission="j_clearance_edit">
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<HiOutlineBanknotes />}
                          disabled={cashFromPosActiveDelay}
                          onClick={() => dispatch(setCashFromPosDialog())}
                          sx={actionButtonSx(TONE.success)}
                        >
                          {cashFromPosActiveDelay ? (
                            <CircularProgress size={18} />
                          ) : (
                            "تسديد دين"
                          )}
                        </Button>
                      </Permission>
                      <Permission permission="j_order_transaction_edit">
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<HiOutlinePlusCircle />}
                          disabled={trasactionActiveDelay}
                          onClick={() => dispatch(setJTransactionDialog())}
                          sx={actionButtonSx(TONE.brand)}
                        >
                          {trasactionActiveDelay ? (
                            <CircularProgress size={18} />
                          ) : (
                            "اضافة حركة مالية"
                          )}
                        </Button>
                      </Permission>
                      <Permission permission="j_clearance_edit">
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<HiOutlineArrowDownTray />}
                          disabled={cashFromRepActiveDelay}
                          onClick={() => dispatch(setCashFromRepDialog())}
                          sx={actionButtonSx("#0e9384")}
                        >
                          {cashFromRepActiveDelay ? (
                            <CircularProgress size={18} />
                          ) : (
                            "استلام نقد"
                          )}
                        </Button>
                      </Permission>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
          {user.role === "pos" ? (
            <Grid item xs={12} md={2}>
              <TextField
                size="small"
                value={search.number}
                onChange={(e) => {
                  setSearch({
                    ...search,
                    number: e.target.value,
                  });
                }}
                label="بحث عن رقم المناقلة"
                fullWidth
              />
            </Grid>
          ) : null}
          {user.role === "pos" ? (
            <Grid item xs={12} md={2}>
              <SelectJTransaction
                onChange={(e, newValue) => {
                  setSearch({
                    ...search,
                    j_type_id: newValue ? newValue.id : null,
                  });
                }}
                value={
                  _JTransactionTypes.filter(
                    (x) => x.id === search.j_type_id
                  )[0] ?? null
                }
              />
            </Grid>
          ) : null}
          <Grid item xs={12} md={2}>
            <TextField
              size="small"
              value={search.order_number}
              onChange={(e) => {
                setSearch({
                  ...search,
                  order_number: e.target.value,
                });
              }}
              label="بحث عن رقم الطلب"
              fullWidth
            />
          </Grid>
          {user.role !== "pos" ? (
            <Grid item xs={12} md={2}>
              <Autocomplete
                options={[
                  { label: "استلام", value: 1 },
                  { label: "تسديد", value: 0 },
                ]}
                value={
                  search.is_received === null
                    ? null
                    : [
                        { label: "استلام", value: 1 },
                        { label: "تسديد", value: 0 },
                      ].find((o) => o.value === search.is_received) || null
                }
                onChange={(e, newValue) =>
                  setSearch({
                    ...search,
                    is_received: newValue ? newValue.value : null,
                  })
                }
                renderInput={(params) => (
                  <TextField {...params} size="small" label="نوع العملية" />
                )}
                clearOnEscape
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
              />
            </Grid>
          ) : null}
          {user.role !== "pos" ? (
            <Grid item xs={12} md={3}>
              <DateRangepicker
                startDate={search.startDate}
                endDate={search.endDate}
                handleOnChange={(searchDate) => {
                  const updatedFilter = {
                    from: dayjs(searchDate[0].startDate).format("YYYY-MM-DD"),
                    to: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                  };
                  if (
                    updatedFilter.from !== searchDate.startDate ||
                    updatedFilter.to !== searchDate.endDate
                  ) {
                    setSearch({
                      ...search,
                      startDate: dayjs(searchDate[0].startDate).format(
                        "YYYY-MM-DD"
                      ),
                      endDate: dayjs(searchDate[0].endDate).format(
                        "YYYY-MM-DD"
                      ),
                    });
                  }
                }}
              />
            </Grid>
          ) : null}
          {user.role !== "pos" ? (
            <Grid item xs={12} md={2}>
              <SelectPos
                onChange={(e, newValue) => {
                  setSearch({
                    ...search,
                    pos_user_id: newValue ? newValue.user_id : null,
                  });
                }}
                value={
                  _PointsOfsales.posesList?.data?.filter(
                    (x) => x.user_id === search.pos_user_id
                  )[0] ?? null
                }
              />
            </Grid>
          ) : null}
          {user.role === "pos" ? (
            <Grid item xs={12} md={3}>
              <DateRangepicker
                startDate={search.startDate}
                endDate={search.endDate}
                handleOnChange={(searchDate) => {
                  const updatedFilter = {
                    from: dayjs(searchDate[0].startDate).format("YYYY-MM-DD"),
                    to: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                  };
                  if (
                    updatedFilter.from !== searchDate.startDate ||
                    updatedFilter.to !== searchDate.endDate
                  ) {
                    setSearch({
                      ...search,
                      startDate: dayjs(searchDate[0].startDate).format(
                        "YYYY-MM-DD"
                      ),
                      endDate: dayjs(searchDate[0].endDate).format(
                        "YYYY-MM-DD"
                      ),
                    });
                  }
                }}
              />
            </Grid>
          ) : null}
          {user.role !== "pos" ? (
            <Grid item xs="auto" md={1}>
              <Stack direction="row" spacing={0} sx={{ alignItems: "center" }}>
                <Tooltip title="الغاء الفلتر">
                  <IconButton
                    onClick={() => {
                      setSearch({
                        search: "",
                        order_id: "",
                        user_type: null,
                        date: "",
                        j_type_id: null,
                        is_received: null,
                        startDate: null,
                        endDate: null,
                        skip: 0,
                        take: 15,
                        number: "",
                        order_number: "",
                        pos_user_id: null,
                      });
                      setPageSize(15);
                      setCurrentPage(0);
                    }}
                  >
                    <MdOutlineClear />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Grid>
          ) : null}
          {/* <Grid item xs={12} md={3}>
            <DateRangepicker
              startDate={search.startDate}
              endDate={search.endDate}
              handleOnChange={(searchDate) => {
                const updatedFilter = {
                  from: dayjs(searchDate[0].startDate).format("YYYY-MM-DD"),
                  to: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                };
                if (
                  updatedFilter.from !== searchDate.startDate ||
                  updatedFilter.to !== searchDate.endDate
                ) {
                  setSearch({
                    ...search,
                    startDate: dayjs(searchDate[0].startDate).format(
                      "YYYY-MM-DD"
                    ),
                    endDate: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                  });
                }
              }}
            />
          </Grid> */}
          {user.role === "pos" ? (
            <Grid item xs="auto" md={1}>
              <Stack direction="row" spacing={0} sx={{ alignItems: "center" }}>
                <Tooltip title="الغاء الفلتر">
                  <IconButton
                    onClick={() => {
                      setSearch({
                        search: "",
                        order_id: "",
                        user_type: null,
                        date: "",
                        j_type_id: null,
                        is_received: null,
                        startDate: null,
                        endDate: null,
                        skip: 0,
                        take: 15,
                        number: "",
                        order_number: "",
                        pos_user_id: null,
                      });
                      setPageSize(15);
                      setCurrentPage(0);
                    }}
                  >
                    <MdOutlineClear />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Grid>
          ) : null}
          <Grid item xs={12}>
            {user.role === "pos" ? (
              smallScreen ? (
                <Grid item xs={12}>
                  <MobileListShell loading={_JTransactions.loading}>
                    {_JPosTransactions?.data?.length > 0 ? (
                      <>
                        {_JPosTransactions.data.map((row, index) => (
                          <MobileListItem
                            key={index}
                            avatar={<HiOutlineArrowsRightLeft />}
                            title={`مناقلة #${row.number}`}
                            subtitle={dayjs(row.created_at).format(
                              "YYYY-MM-DD · hh:mm a"
                            )}
                            badge={
                              row.j_type_name ? (
                                <MobileBadge label={row.j_type_name} />
                              ) : null
                            }
                            highlight={{
                              label: "القيمة",
                              value: (row.amount ?? 0).toLocaleString(),
                              unit: "IQD",
                            }}
                            fields={[
                              {
                                label: "رقم الطلب",
                                span: 12,
                                value: (
                                  <Link
                                    href={`/app/wholesale/order/${row.j_order_id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {row.j_order_number}
                                  </Link>
                                ),
                              },
                              { label: "بواسطة", value: row.created_by },
                              {
                                label: "الديون السابقة (IQD)",
                                value: row.pos_j_balance?.toLocaleString(),
                              },
                              {
                                label: "الديون الحالية (IQD)",
                                span: 12,
                                value: row.new_pos_j_balance?.toLocaleString(),
                              },
                            ]}
                            note={row.note}
                          />
                        ))}
                        <MobilePagination
                          count={_JPosTransactions.total ?? 0}
                          rowsPerPage={pageSize}
                          page={currentPage}
                          onPageChange={(e, newPage) => setCurrentPage(newPage)}
                          rowsPerPageOptions={[15, 25, 50, 100]}
                          onRowsPerPageChange={(event) => {
                            const newRowsPerPage = parseInt(
                              event.target.value,
                              10
                            );
                            setPageSize(newRowsPerPage);
                          }}
                        />
                      </>
                    ) : (
                      <MobileEmpty />
                    )}
                  </MobileListShell>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Box sx={{ height: "45vh", width: "100%" }}>
                    <DataGrid
                      rows={_JPosTransactions.data}
                      columns={posColumns}
                      pageSize={pageSize}
                      page={currentPage}
                      rowCount={_JPosTransactions.total}
                      loading={_JTransactions.loading}
                      rowHeight={65}
                      pagination
                      paginationMode="server"
                      selectionModel={[]}
                      onPageChange={(newPage) => {
                        setCurrentPage(newPage);
                      }}
                      rowsPerPageOptions={[15, 25, 50, 100]}
                      onPageSizeChange={(newPageSize) => {
                        setPageSize(newPageSize);
                      }}
                      components={{
                        LoadingOverlay: LinearProgress,
                        Footer: CustomFooter,
                        Toolbar: customToolbar,
                      }}
                    />
                  </Box>
                </Grid>
              )
            ) : smallScreen ? (
              <Grid item xs={12}>
                <MobileListShell loading={_JTransactions.loading}>
                  {_JTransactions?.data?.length > 0 ? (
                    <>
                      {_JTransactions.data.map((row, index) => (
                        <MobileListItem
                          key={index}
                          avatar={<HiOutlineArrowsRightLeft />}
                          avatarTone={
                            row.is_received ? TONE.success : TONE.danger
                          }
                          title={`مناقلة #${row.number}`}
                          subtitle={dayjs(row.created_at).format(
                            "YYYY-MM-DD · hh:mm a"
                          )}
                          badge={
                            <MobileBadge
                              label={row.is_received ? "استلام" : "تسديد"}
                              tone={
                                row.is_received ? TONE.success : TONE.danger
                              }
                            />
                          }
                          highlight={{
                            label: "القيمة",
                            value: (row.amount ?? 0).toLocaleString(),
                            unit: "IQD",
                          }}
                          fields={[
                            { label: "نقطة البيع", value: row.pos_user_name },
                            { label: "المندوب", value: row.rep_name },
                            { label: "بواسطة", value: row.created_by_name },
                            {
                              label: "الرصيد السابق (IQD)",
                              value: row.rep_j_cash?.toLocaleString(),
                            },
                            {
                              label: "الرصيد الحالي (IQD)",
                              span: 12,
                              value: row.rep_new_j_cash?.toLocaleString(),
                            },
                          ]}
                          note={row.note}
                        />
                      ))}
                      <MobilePagination
                        count={_JTransactions.total ?? 0}
                        rowsPerPage={pageSize}
                        page={currentPage}
                        onPageChange={(e, newPage) => setCurrentPage(newPage)}
                        rowsPerPageOptions={[15, 25, 50, 100]}
                        onRowsPerPageChange={(event) => {
                          const newRowsPerPage = parseInt(
                            event.target.value,
                            10
                          );
                          setPageSize(newRowsPerPage);
                        }}
                      />
                    </>
                  ) : (
                    <MobileEmpty />
                  )}
                </MobileListShell>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Box
                  sx={{
                    height: user.role === "pos" ? "45vh" : "60vh",
                    width: "100%",
                  }}
                >
                  <DataGrid
                    rows={_JTransactions.data}
                    columns={columns}
                    pageSize={pageSize}
                    page={currentPage}
                    rowCount={_JTransactions.total}
                    loading={_JTransactions.loading}
                    rowHeight={65}
                    pagination
                    paginationMode="server"
                    selectionModel={[]}
                    onPageChange={(newPage) => {
                      setCurrentPage(newPage);
                    }}
                    rowsPerPageOptions={[15, 25, 50, 100]}
                    onPageSizeChange={(newPageSize) => {
                      setPageSize(newPageSize);
                    }}
                    components={{
                      LoadingOverlay: LinearProgress,
                      Footer: CustomFooter,
                      Toolbar: customToolbar,
                    }}
                  />
                </Box>
              </Grid>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default JTransactionTable;
